var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo",class:( _obj = {dark: _vm.isDark}, _obj[_vm.size] = _vm.size, _obj ),attrs:{"href":"https://simplecast.com","target":"simplecast","title":"Simplecast Homepage"}},[_c('IconLogo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }